const option = [
    { id: 1, name: 'รอผลการเคลม' },
    { id: 2, name: 'ปิดเคลม' }
]

export default {
    option: option
};